module.exports = __webpack_public_path__ + "static/media/july-profile.adad4176.jpg";